import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom"; // ✅ 이거 추가
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hospital1 from "../../../assets/images/hospital1.png";
import hospital2 from "../../../assets/images/hospital2.png";
import hospital3 from "../../../assets/images/hospital3.png";
import hospital4 from "../../../assets/images/hospital4.png";

import partner1 from "../../../assets/images/partner1.png";
import partner2 from "../../../assets/images/partner2.png";
import partner3 from "../../../assets/images/partner3.png";
import partner4 from "../../../assets/images/partner4.png";
import partner5 from "../../../assets/images/partner5.png";
import partner6 from "../../../assets/images/partner6.png";
import partner7 from "../../../assets/images/partner7.png";
import partner8 from "../../../assets/images/partner8.png";
import partner9 from "../../../assets/images/partner9.png";
import partner10 from "../../../assets/images/partner10.png";
import partner11 from "../../../assets/images/partner11.png";

const hospitalImgs = [hospital1, hospital2, hospital3, hospital4];
const partnerImgs = [
  partner1,
  partner2,
  partner3,
  partner4,
  partner5,
  partner6,
  partner7,
  partner8,
  partner9,
  partner10,
  partner11,
];

const PartnerShip = () => {
  const location = useLocation(); // ✅ 여기에
  // 병원 슬라이드
  const [hospitalList, setHospitalList] = useState([]);
  const hospitalRef = useRef(null);

  // 슬라이드 상태
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  // 섹션 앵커
  const hospitalSectionRef = useRef(null);
  const didAutoScroll = useRef(false);

  // 협력업체 리스트
  const [partnerList, setPartnerList] = useState([]);
  const itemsPerPage = 999999;

  // ✅ Link에서 state로 넘어온 경우 스크롤
  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const el = document.getElementById(location.state.scrollTo);
        if (el) smoothScrollTo(el);
      }, 200);
    }
  }, [location]);

  // 1줄: 병원
  const settingsTop = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 19000,
    autoplaySpeed: 0,
    cssEase: "linear",
    rtl: false,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  // 2줄: 협력업체 1~5
  const settingsBottom = {
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 19000,
    autoplaySpeed: 0,
    cssEase: "linear",
    rtl: true,
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  // 3줄: 협력업체 6~10 (왼쪽 방향)
  const settingsBottomLeft = {
    ...settingsBottom,
    rtl: false,
  };

  useEffect(() => {
    const fetchHospital = async () => {
      try {
        const { data } = await axios.get(
          "https://www.medicode.co.kr:8445/api/get/board_list",
          {
            params: { cate: "hospital", page: 1, pageSize: itemsPerPage },
          }
        );
        setHospitalList(data.data || []);
      } catch (e) {
        console.error("Error fetching hospital:", e);
      }
    };
    const fetchPartner = async () => {
      try {
        const { data } = await axios.get(
          "https://www.medicode.co.kr:8445/api/get/board_list",
          {
            params: { cate: "partner", page: 1, pageSize: itemsPerPage },
          }
        );
        setPartnerList(data.data || []);
      } catch (e) {
        console.error("Error fetching partner:", e);
      }
    };
    fetchHospital();
    fetchPartner();
  }, []);

  const smoothScrollTo = (targetEl) => {
    if (!targetEl) return;
    const startY = window.scrollY;
    const targetY = targetEl.getBoundingClientRect().top + window.scrollY;
    const distance = targetY - startY;
    const duration = 1600;
    const startTime = performance.now();
    const easeInOutCubic = (t) =>
      t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

    const animate = (now) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeInOutCubic(progress);
      window.scrollTo(0, startY + distance * eased);
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  };

  const handleIndicatorClick = () => {
    smoothScrollTo(hospitalSectionRef.current);
  };

  // ✅ 이 페이지 원래 있던 “처음 휠/터치하면 hospital-section으로 내려가는” 로직
  // 근데 우리는 위에서 partner-section으로 이미 내려간 경우엔 이거 안 타게 했음
  useEffect(() => {
    const handler = () => {
      if (didAutoScroll.current) return;
      didAutoScroll.current = true;
      smoothScrollTo(hospitalSectionRef.current);
    };
    window.addEventListener("wheel", handler, { passive: true });
    window.addEventListener("touchstart", handler, { passive: true });
    return () => {
      window.removeEventListener("wheel", handler);
      window.removeEventListener("touchstart", handler);
    };
  }, []);

  const totalSlides = hospitalList.length || 0;

  const goToSlide = (index) => {
    const el = hospitalRef.current;
    if (!el || totalSlides === 0) return;

    const normalized = ((index % totalSlides) + totalSlides) % totalSlides;
    const targetLeft = normalized * el.clientWidth;

    el.scrollTo({ left: targetLeft, behavior: "smooth" });
    setCurrentSlide(normalized);
  };

  const scrollSlide = (dir) => {
    if (dir === "next") goToSlide(currentSlide + 1);
    else goToSlide(currentSlide - 1);
  };

  useEffect(() => {
    if (!isPlaying) return;
    if (!hospitalRef.current) return;
    if (totalSlides <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => {
        const nextIndex = totalSlides === 0 ? 0 : (prev + 1) % totalSlides;
        const el = hospitalRef.current;
        if (el && totalSlides > 0) {
          const targetLeft = nextIndex * el.clientWidth;
          el.scrollTo({ left: targetLeft, behavior: "smooth" });
        }
        return nextIndex;
      });
    }, 4000);

    return () => clearInterval(interval);
  }, [isPlaying, totalSlides]);

  useEffect(() => {
    const el = hospitalRef.current;
    if (!el) return;

    const handleScroll = () => {
      if (!el.clientWidth) return;
      const idx = Math.round(el.scrollLeft / el.clientWidth);
      setCurrentSlide(idx);
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [totalSlides]);

  const progressPercent =
    totalSlides > 0 ? ((currentSlide + 1) / totalSlides) * 100 : 0;

  return (
    <>
      {/* Quick Menu */}
      <div className="quick-menu">
        <button
          type="button"
          className="quick-btn"
          onClick={() =>
            document
              .getElementById("hospital-section")
              ?.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          협력병원
        </button>
        <button
          type="button"
          className="quick-btn"
          onClick={() =>
            document
              .getElementById("partner-section")
              ?.scrollIntoView({ behavior: "smooth", block: "start" })
          }
        >
          협력업체
        </button>
      </div>

      {/* 스크롤 인디케이터 */}
      <div className="scroll-indicator hospital" onClick={handleIndicatorClick}>
        <span className="scroll-label">
          아래로 스크롤하여 협력업체를 확인하세요
        </span>
        <div className="circle">
          <div className="arrow" />
        </div>
      </div>

      <div className="hospital-wrap">
        {/* ====== 상단 히어로 + 로고 슬라이드 ====== */}
        <div className="hospital-top">
          <div className="page-tit">
            <div className="hospital-wrapper">
              <h2>
                PARTNERSHIP
                <span>메디코드와 함께 성장하는 협력 업체를 소개합니다.</span>
              </h2>
            </div>
          </div>

          <div className="hospital-center-wrap">
            <p className="h-txt-1">함께할 때, 가치가 완성됩니다.</p>
            <p className="h-txt-2">메디코드는 파트너와의 협력을 통해</p>
            <p className="h-txt-3">
              더 신뢰할 수 있는 헬스케어 서비스를 구축합니다.
            </p>
          </div>

          {/* <div className="partner-slide top-slide">
            <Slider {...settingsTop}>
              {hospitalImgs.map((img, i) => (
                <div key={i} className="slide-item">
                  <img src={img} alt={`hospital-${i}`} />
                </div>
              ))}
            </Slider>
          </div>

          <div className="partner-slide mid-slide">
            <Slider {...settingsBottom}>
              {partnerImgs.slice(0, 5).map((img, i) => (
                <div key={i} className="slide-item">
                  <img src={img} alt={`partner-${i + 1}`} />
                </div>
              ))}
            </Slider>
          </div>

          <div className="partner-slide bottom-slide">
            <Slider {...settingsBottomLeft}>
              {partnerImgs.slice(5, 10).map((img, i) => (
                <div key={i + 5} className="slide-item">
                  <img src={img} alt={`partner-${i + 6}`} />
                </div>
              ))}
            </Slider>
          </div> */}
        </div>

        {/* 섹션: 협력병원 */}
        <section id="hospital-section" ref={hospitalSectionRef}>
          <div className="hero-slider">
            <ul className="hero-track" ref={hospitalRef}>
              {hospitalList.map((row, i) => (
                <li
                  key={`h-${i}`}
                  className="hero-slide"
                  style={{
                    backgroundImage: `url(https://www.medicode.co.kr:8445/uploads/${
                      row.img_cover || row.img2
                    })`,
                  }}
                >
                  <div className="hero-overlay" />
                  <div className="hero-caption">
                    <h3>{row.title}</h3>
                    {row.address && <p>{row.address}</p>}
                    {row.homepage && row.homepage !== "-" ? (
                      <a
                        href={row.homepage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        홈페이지 바로가기
                      </a>
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>

            <div className="hero-controls-wrapper">
              <div className="hero-progress">
                <span className="hero-page-current">
                  {totalSlides > 0 ? currentSlide + 1 : 0}
                </span>
                <div className="hero-progress-bar">
                  <div
                    className="hero-progress-fill"
                    style={{ width: `${progressPercent}%` }}
                  />
                </div>
                <span className="hero-page-total">{totalSlides}</span>
              </div>

              <div className="hero-controls-buttons">
                <button
                  type="button"
                  className="hero-controls-btn"
                  onClick={() => scrollSlide("prev")}
                >
                  ‹
                </button>
                <button
                  type="button"
                  className="hero-controls-btn hero-controls-btn-play"
                  onClick={() => setIsPlaying((prev) => !prev)}
                >
                  {isPlaying ? "Ⅱ" : "▶"}
                </button>
                <button
                  type="button"
                  className="hero-controls-btn"
                  onClick={() => scrollSlide("next")}
                >
                  ›
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* 섹션: 협력업체 그리드 */}
        <section id="partner-section">
          <div className="hospital-grid">
            {partnerList.map((row, index) => (
              <article className="partner-card" key={`p-${index}`}>
                <div className="partner-card-inner">
                  <div className="partner-chip">PARTNER</div>
                  <div className="partner-logo-wrap">
                    <div className="partner-logo-bg" />
                    <img
                      src={`https://www.medicode.co.kr:8445/uploads/${row.img1}`}
                      alt={row.title}
                    />
                  </div>
                  <h3 className="partner-name">{row.title}</h3>
                  <div className="partner-meta">
                    {row.address && (
                      <p className="partner-address">주소: {row.address}</p>
                    )}
                    {row.tel && <p className="partner-tel">{row.tel}</p>}
                  </div>
                  <div className="partner-home">
                    <span className="partner-home-label">
                      홈페이지: {row.homepage}
                    </span>
                    {row.homepage && row.homepage !== "-" ? (
                      <a
                        href={row.homepage}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="partner-home-link"
                      >
                        바로가기
                      </a>
                    ) : (
                      <span className="partner-home-empty">-</span>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default PartnerShip;
